import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    modelList: [],
    categoryList: [],
    trainedMessages: [],
    needTrainModel: false,
  },
  getters: {
    modelList: (state) => state.modelList,
    categoryList: (state) => state.categoryList,
    trainedMessages: (state) => state.trainedMessages,
    needTrainModel: (state) => state.needTrainModel,
  },
  actions: {
    loadModelList(context) {
      context.commit('setNeedTrainModel', false);
      return new Promise((resolve, reject) => {
        alice
          .loadModelList()
          .then((response) => {
            const { data } = response.data;
            data.forEach((model) => {
              const newModel = model;
              if (newModel.lastTrainedAt) {
                newModel.isOutdated = newModel.updatedAt > newModel.lastTrainedAt;
                if (newModel.isOutdated) {
                  context.commit('setNeedTrainModel', true);
                }
              } else {
                newModel.isOutdated = true;
                context.commit('setNeedTrainModel', true);
              }
            });
            context.commit('setModelListData', data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadCategoryList(context, params) {
      const { modelId } = params;
      return new Promise((resolve, reject) => {
        alice
          .loadCategoryList(modelId)
          .then((response) => {
            context.commit('setCategoryListData', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadTrainedMessageList(context, params) {
      const { modelId, categoryId } = params;
      return new Promise((resolve, reject) => {
        alice
          .loadTrainedMessageList(modelId, categoryId)
          .then((response) => {
            context.commit('setTrainedMessageListData', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createModel(context, params) {
      const { modelData } = params;
      return new Promise((resolve, reject) => {
        alice
          .createModel(modelData)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateModel(context, params) {
      const { modelId, modelData } = params;
      return new Promise((resolve, reject) => {
        alice
          .updateModel(modelId, modelData)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteModel(context, params) {
      const { modelId } = params;
      return new Promise((resolve, reject) => {
        alice
          .deleteModel(modelId)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createCategory(context, params) {
      const { modelId, categoryData } = params;
      return new Promise((resolve, reject) => {
        alice
          .createCategory(modelId, categoryData)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateCategory(context, params) {
      const { modelId, categoryId, categoryData } = params;
      return new Promise((resolve, reject) => {
        alice
          .updateCategory(modelId, categoryId, categoryData)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteCategory(context, params) {
      const { modelId, categoryId } = params;
      return new Promise((resolve, reject) => {
        alice
          .deleteCategory(modelId, categoryId)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    clearTrainedData(context) {
      context.commit('setTrainedMessageListData', []);
    },
  },
  mutations: {
    setModelListData(state, data) {
      Vue.set(state, 'modelList', data);
    },
    setCategoryListData(state, data) {
      Vue.set(state, 'categoryList', data);
    },
    setTrainedMessageListData(state, data) {
      Vue.set(state, 'trainedMessages', data);
    },
    setNeedTrainModel(state, data) {
      Vue.set(state, 'needTrainModel', data);
    },
  },
};
